import React, { useEffect, useState } from "react";
import OrderImage from "../../assets/images/eyrbuds-image.png"; // replace with your image
import CoinIcon from "../../assets/images/coin-image.svg"; // replace with your icon
import { Button } from "antd";
import Main from "../../components/layout/Main";
import { ShoppingCart } from "lucide-react";
import TrackOrderModal from "./OrderTrackingModal";
import LeaveFeedbackModal from "./LeaveFeedbackModal";
import { useStore } from "../../context/StoreContext";
import { useParams } from "react-router";
import moment from "moment";
import { isValidUrl } from "../../helper/functions";
import ReturnItemsModal from "../../components/ReturnItemsModal";
import { Severty, ShowToast } from "../../helper/toast";

const OrderIdDetailsPage = ({}) => {
  const { id } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [returnOpen, setReturnOpen] = useState(false);
  const [thanksOpen, setThanksOpen] = useState(false);
  const { loadOrderById, requestRefund } = useStore();
  const [order, setOrder] = useState(null);

  // ------------ handlers ------------
  const fetchOrder = async () => {
    const response = await loadOrderById(id);
    setOrder(response.data);
  };

  const handleRefund = async (values) => {
    try {
      values.orderId = id;
      const response = await requestRefund(values);
      if (response.status === 200) {
        ShowToast(response.data.message, Severty.SUCCESS);
        setReturnOpen(false);
        fetchOrder();
      }
    } catch (error) {
      ShowToast(error.message, Severty.ERROR);
      setReturnOpen(false);
      console.log("Error occured while refund order", error);
    }
  };

  // ------------ use effect ------------
  useEffect(() => {
    fetchOrder();
  }, [id]);

  return (
    <Main>
      <div className="section-main">
        <div className="order-details-wrapper">
          <div className="order-card-header">
            <div className="order-name-id">
              <h2>
                Order <span>{order?.orderId}</span>{" "}
                <span className="order-date">
                  {moment(order?.eta).format("MMM Do YY")}
                </span>
              </h2>
            </div>

            <Button className="delivery-sucses-btn">{order?.status}</Button>
            {/* <Button className="delivery-accepted-btn">Accepted</Button> */}
          </div>

          {order?.refundRequests?.length > 0 && (
            <div className="refund-banner">
              <i className="icon-info">i</i>
              <span>
                Refund requested for {order?.refundRequests.length} item(s)
              </span>
            </div>
          )}

          <div className="edit-profile-actions">
            {/* <Button className="fill-button-smal"><ShoppingCart /> Reorder</Button> */}
            <Button
              className="fill-button-smal"
              onClick={() => setIsModalOpen(true)}
            >
              Track order
            </Button>
            {(order?.status === "Delivered" ||
              order?.status === "delivered") && (
              <Button
                className="social-btn"
                onClick={() => setFeedbackOpen(true)}
              >
                Leave feedback
              </Button>
            )}

            {order?.status === "Delivered" ||
              (order?.status === "delivered" && (
                <Button
                  className="social-btn"
                  onClick={() => setReturnOpen(true)}
                >
                  Return Order (Refund)
                </Button>
              ))}
          </div>

          <hr className="divider" />

          <div className="order-main-content">
            {/* Left - Ordered Products */}
            <div className="ordered-products">
              <h3>Ordered products ({order?.items?.length})</h3>

              {order?.items?.map((item, index) => (
                <div className="product-item" key={index}>
                  <img
                    src={isValidUrl(item?.image) ? item?.image : OrderImage}
                    alt="Product"
                  />
                  <div>
                    <p className="product-name">{item?.name}</p>
                    <p className="product-qty">{item?.quantity} items</p>
                    <div className="product-price">
                      <img src={CoinIcon} alt="Coin" />
                      <span>{item?.price}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Right - Order Details */}
            <div className="order-summary">
              <h3>Order details</h3>

              <div className="order-section-summry">
                <h6>Delivery information</h6>
                <p>
                  {order?.address?.name},
                  <br />
                  {order?.address?.mobileNumber}
                  <br />
                  {order?.address?.fullAddress}
                </p>
              </div>

              <hr className="divider" />

              <div className="order-section-summry">
                <h6>Payment method</h6>
                <p>{order?.paymentMethod}</p>
              </div>

              <hr className="divider" />

              <div className="order-totals">
                <div className="total-row">
                  <span>Total tokens ({order?.items?.length} items)</span>
                  <span>
                    <img src={CoinIcon} alt="Coin" /> {order?.amount}
                  </span>
                </div>
                <div className="total-row">
                  <span>Shipping fee</span>
                  <span>7.00</span>
                </div>
                <div className="total-row grand-total">
                  <span>Grand total</span>
                  <span>
                    <img src={CoinIcon} alt="Coin" />{" "}
                    {Number(order?.amount) + 7}
                  </span>
                </div>
                <hr className="divider" />
                <div className="total-row total-bold">
                  <span>TOTAL</span>
                  <span>
                    <img src={CoinIcon} alt="Coin" />{" "}
                    {Number(order?.amount) + 7}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <TrackOrderModal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          step={0}
          order={order}
        />
        <LeaveFeedbackModal
          open={feedbackOpen}
          onClose={() => setFeedbackOpen(false)}
        />
      </div>
      {/* --------- Return Modal ---------- */}
      <ReturnItemsModal
        open={returnOpen}
        onClose={() => setReturnOpen(false)}
        order={order}
        onSubmit={handleRefund}
      />
    </Main>
  );
};

export default OrderIdDetailsPage;
